import $ from 'jquery';

const $svgEl = $('.svg-lazy');

$(function () {
    if ($svgEl.length > 0) {
        $svgEl.each(function () {
            const $thisEl = $(this);
            svgTag($thisEl);
        });
    }
});

const svgTag = async (el) => {
    const data = await loadSvgFile(el.data('url'));
    if (data) {
        el.replaceWith(new XMLSerializer().serializeToString(data.documentElement));
    }
};

const loadSvgFile = async (path) => {
    try {
        const data = await $.ajax({
            url: path,
            type: 'GET',
        });

        return data;
    } catch (e) {
        console.log(e);
        return null;
    }
};
